import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

interface ContentProps {
  width: number | string
}

export const Wrapper = styled.div`
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1300;
  background-color: rgba(26, 26, 30, 0.5);
`

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width)};
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.md};
  background: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.md};
  box-shadow: ${theme.effects.boxShadow['rule-01']};
  max-height: 95vh;
`

export const Head = styled.div`
  display: flex;
  width: 100%;
  gap: ${theme.spacing.sm};
  align-items: center;
  justify-content: space-between;
`

export const HeadTexts = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.span`
  font-family: ${theme.typography.family.bold};
  color: ${theme.colors.neutral.black};
  font-weight: ${theme.typography.weight.lg};
  line-height: ${theme.typography.lineHeight.md};

  ${({ titleSize }: { titleSize: number }) => `font-size: ${titleSize}px;`}
`

export const Description = styled.span`
  font-family: ${theme.typography.family.primary};
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes.xs};
  line-height: ${theme.typography.lineHeight.md};
`

export const CloseButton = styled.button`
  align-self: flex-start;
  cursor: pointer;
  border: 0;
  padding: 0;
  outline: none;
  background: none;
  padding: ${theme.spacing.xs};
  transform: scale(0.8);

  svg {
    path {
      fill: ${theme.colors.primary.main};
    }
  }
`
